// Single source of truth for the quotation PDF's display name / filename, so the
// name shown on-screen (Approved/Scheduled/Upcoming/Past tabs) is always identical
// to what gets saved when the file is downloaded.
// Strips only filesystem-reserved characters — Vietnamese diacritics and other
// Unicode letters are preserved.
export const buildQuotationFileName = (patientName, hnNumber) => {
  const formattedName = patientName
    ? String(patientName)
        .trim()
        .replace(/[\\/:*?"<>|]/g, "")
        .replace(/\s+/g, "-")
    : "";
  const hn = hnNumber ? String(hnNumber).trim() : "";
  if (formattedName) return `${formattedName}${hn ? `_${hn}` : ""}-Quotation.pdf`;
  if (hn) return `${hn}-Quotation.pdf`;
  return null;
};
